module.exports = __webpack_public_path__ + "img/notice3.e62b658a.png";